/** Text styling shared by Label, FormLabel, and inline choice option labels. */
export const labelTextClassName =
  "text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50";

/**
 * Static group labels (segmented control, choice group) — same size as a floated FormLabel
 * (`0.75rem` / 12px), not the resting 14px input placeholder.
 */
export const formGroupLabelClassName =
  "text-xs leading-4 font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50";

/** Floating label: layout comes from `.floating-field__label` in globals.css. */
export const floatingLabelClassName =
  "floating-field__label select-none font-medium group-data-[disabled=true]:opacity-50";

/** Helper text styling shared by FormDescription and choice option descriptions. */
export const formDescriptionClassName = "text-muted-foreground text-xs";
